// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full_modal_resize[data-v-2b9145a8]{color:#2b2f31!important;position:absolute;right:3.5rem;top:.25rem}:root[dir=rtl] .full_modal_resize[data-v-2b9145a8]{left:3.5rem;right:inherit}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
